module.exports = __webpack_public_path__ + "static/theme-editor-special-products-columns-5b6fbff269486605a8b632cd949b7490.png";